
import AutoComplete from "../../Forms/Autocomplete";
import Select from "../../Forms/Select";
import Button from "../../Forms/Button";
import Modal from 'react-modal';
import { AmazonItemsBinded, ProductTaxes, AmazonItemBinder } from "../../../models/Items";
import React, { useEffect, FormEvent, useState } from "react";
import { Subject } from "rxjs";
import { fiscalpopApi } from "../../../services/fiscalpopApi";
import { debounceTime } from "rxjs/operators";
import sharedToasterSubject from "../../../services/shared.toasterSubject";
import Checkbox from "../../Forms/Checkbox";
import Input from "../../Forms/Input";


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        border: 'none',
        boxShadow: '3px 4px 15px rgba(170, 170, 208, 0.5)',
        transform: 'translate(-50%, -50%)',
        overflow: 'visible'
    }
};
Modal.setAppElement('#root');

interface ItemModalProps {
    modalIsOpen: boolean;
    item: AmazonItemsBinded;
    onClose: (save: boolean, binder: AmazonItemBinder) => void;
}


function ItemEditModal({ modalIsOpen, item, onClose }: ItemModalProps) {

    useEffect(() => {
        if (item && item.binder) {
            console.log('[ITEM EDIT MODAL] UEf - item: ', item.binder);
            setDefaultClaveSatProdServ(item.binder.claveProdServ);
            setDefaultUnidadSat(item.binder.claveUnidad);
            fetchClaves(item.binder.claveProdServ);
            fetchUnidad(item.binder.claveUnidad);
            setPedimento(item.binder.pedimento || '');
            setIsPedimento(item.binder.pedimento ? true : false);
            item.binder.taxes.forEach((tax) => {
                if (tax.type === 'iva') {
                    if (tax.exento) {
                        setIvaOption('0-exento');
                    } else if (tax.tasa === 0) {
                        setIvaOption('0');
                    } else {
                        setIvaOption('0.16');
                    }
                }
                if (tax.type === 'ieps') {
                    setIEPS(tax.tasa);
                }
            })
        } else {
            setDefaultClaveSatProdServ('');
            setDefaultUnidadSat('');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item])

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault();
        const ivaExento = ivaOption === '0-exento';
        const ivaTasa = ivaExento ? 0 : parseFloat(ivaOption);
        const ivaTax: ProductTaxes = {
            type: 'iva',
            tipo: 'Fijo',
            exento: ivaExento,
            tasa: ivaTasa,
            retencion: false,
        }
        const iepsTax: ProductTaxes = !ieps ? null : {
            type: 'ieps',
            tipo: 'Fijo',
            exento: false,
            tasa: ieps,
            retencion: false,
        }
        const binder: AmazonItemBinder = {
            productId: item.item.productId,
            claveProdServ: defaultClaveSatProdServ,
            claveUnidad: defaultUnidadSat,
            taxes: [ivaTax, iepsTax].filter(t => t !== null)
        }
        const claveValid = await fetchClavesByKey(defaultClaveSatProdServ);
        if (!claveValid) {
            return sharedToasterSubject.next({
                type: 'error',
                message: `La clave de producto para ${item.item.asin1} no es válida, escoje una de las opciones mostradas al escribir`
            })
        }
        const unidadValid = await fetchUnidadByKey(defaultUnidadSat);
        if (!unidadValid) {
            return sharedToasterSubject.next({
                type: 'error',
                message: `La clave de unidad para ${item.item.asin1} no es válida, escoje una de las opciones mostradas al escribir`
            })
        }
        if (isPedimento) {
            binder.pedimento = pedimento;
            if (pedimento.length !== 21) {
                return sharedToasterSubject.next({
                    type: 'error',
                    message: `Clave de pedimento incorrecta, revise el formato o desactive la opción "Usa pedimento"`
                })
            }
        } else {
            // Remove pedimento if unChecked
            binder.pedimento = null;
        }

        console.log('Binder Taxes: ', binder.taxes);
        onClose(true, binder);
    }

    const onCancel = () => {
        onClose(false, null);
    }

    const [ieps, setIEPS] = useState<number>(0);
    const [ivaOption, setIvaOption] = useState<string>('0.16');
    const [isLoading, setIsLoading] = useState(false);
    const [defaultClaveSatProdServ, setDefaultClaveSatProdServ] = useState(!!item && item.binder ? item.binder.claveProdServ : '');
    const [defaultUnidadSat, setDefaultUnidadSat] = useState(!!item && item.binder ? item.binder.claveUnidad : '');
    const [claveOptions, setClaveOptions] = useState<{ label: string, value: string }[]>([])
    const [unidadOptions, setUnidadOptions] = useState<{ label: string, value: string }[]>([])
    const [prodServErr, setProdServErr] = useState(false);
    const [unidadErr, setUnidadErr] = useState(false);

    // Pedimento case
    const [isPedimento, setIsPedimento] = useState(false)
    const [pedimento, _setPedimento] = useState('')

    const [unitSubject] = useState<Subject<string>>(new Subject());
    const [claveSubject] = useState<Subject<string>>(new Subject());

    const fetchClaves = (defaultClaveSatProdServ: string) => {
        console.log('[SETUP - DEFAULTS] Fetching claves: ', defaultClaveSatProdServ);
        setIsLoading(true);
        return fiscalpopApi.sat.searchProductosServicios({
            compare: defaultClaveSatProdServ,
            clave: defaultClaveSatProdServ
        }).then(response => {
            setIsLoading(false);
            setClaveOptions(response.map(r => ({ label: `(${r.clave}) ${r.descripcion ?? r.nombre ?? ''}`, value: r.clave })))
        })
    }

    const fetchUnidad = (defaultUnidadSat: string) => {
        setIsLoading(true);
        return fiscalpopApi.sat.searchClaveUnidades({
            compare: defaultUnidadSat,
            clave: defaultUnidadSat
        }).then(response => {
            setIsLoading(false);
            setUnidadOptions(response.map(r => ({ label: `(${r.clave}) ${r.nombre ?? r.descripcion ?? ''}`, value: r.clave })))
        })
    }

    const fetchClavesByKey = (clave: string) => {
        return fiscalpopApi.sat.searchProductosServicios({
            clave: clave
        }).then(response => response.some(r => r.clave === clave))
    }
    const fetchUnidadByKey = (clave: string) => {
        return fiscalpopApi.sat.searchClaveUnidades({
            clave: clave
        }).then(response => response.some(r => r.clave === clave))
    }

    const claveProdErrTest = () => {
        const isValidProdServ = claveOptions.find(o => o.value.toLowerCase() === (defaultClaveSatProdServ || '').toLowerCase());
        if (!isValidProdServ) {
            setProdServErr(true);
        }
    }

    const unitErrTest = () => {
        // Can be empty for later addition
        if (!defaultUnidadSat) {
            return setUnidadErr(false);
        }
        const isValidUnidad = unidadOptions.find(o => o.value.toLowerCase() === (defaultUnidadSat || '').toLowerCase());
        if (!isValidUnidad) {
            setUnidadErr(true);
        }
    }

    useEffect(() => {
        fetchClaves('');
        fetchUnidad('');
        console.log('[SETUP - DEFAULTS] useEffect!');
        const claveSubs = claveSubject.pipe(debounceTime(350)).subscribe(claveProdServ => {
            console.log('[SETUP - DEFAULTS] clave subs: ', claveProdServ, defaultClaveSatProdServ);
            fetchClaves(claveProdServ);
        })
        const unitSubs = unitSubject.pipe(debounceTime(350)).subscribe(claveUnidad => {
            fetchUnidad(claveUnidad);
        })

        return () => {
            console.log('[SETUP - DEFAULTS] useEffect closed');
            claveSubs.unsubscribe();
            unitSubs.unsubscribe();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onClaveChange = (claveProdServ: string) => {
        setDefaultClaveSatProdServ(claveProdServ);
        setProdServErr(false);
        claveSubject.next(claveProdServ);
    }
    const onUnidadChange = (claveUnidad: string) => {
        setDefaultUnidadSat(claveUnidad);
        setUnidadErr(false);
        unitSubject.next(claveUnidad);
    }

    const onSelectedClaveProd = (claveSatProdServ: string) => {
        console.log('onSelectedClaveProd: ', claveSatProdServ);
        setDefaultClaveSatProdServ(claveSatProdServ);
        setProdServErr(false);
    }

    const onSelectedUnidad = (unidadSat: string) => {
        setDefaultUnidadSat(unidadSat);
        setUnidadErr(false);
    }

    const setPedimento = (pedimentoText: string) => {
        // Define step split cases
        pedimentoText = pedimentoText.trimRight()

        const formattedText = pedimentoText.split('').filter(s => s !== ' ').reduce((p, letter, index) => {
            if (p.length === 2) {
                // First split case double space
                p.push(...[' ', ' '])
            }
            if (p.length === 6) {
                // First split case double space
                p.push(...[' ', ' '])
            }
            if (p.length === 12) {
                // First split case double space
                p.push(...[' ', ' '])
            }
            if (p.length === 21) {
                // Max Size is 21 Chars
                return p;
            }
            p.push(letter)
            return p;
        }, [] as string[]).join('').trimRight()

        return _setPedimento(formattedText);
    }

    const ivaOptions = [
        { value: '0.16', label: 'IVA 16%' },
        { value: '0', label: 'IVA 0%' },
        { value: '0-exento', label: 'IVA Exento' },
    ];
    const iepsOptions = [
        { value: '', label: 'Sin IEPS' },
        { value: 0.3, label: 'IEPS 30%' },
        { value: 0.265, label: 'IEPS 26.5%' },
        { value: 1.6, label: 'IEPS 160%' },
        { value: 0.53, label: 'IEPS 53%' },
        { value: 0.304, label: 'IEPS 30.4%' },
        { value: 0.5, label: 'IEPS 50%' },
        { value: 0.07, label: 'IEPS 7%' },
        { value: 0.25, label: 'IEPS 25%' },
        { value: 0.06, label: 'IEPS 6%' },
        { value: 0.08, label: 'IEPS 8%' },
        { value: 0.09, label: 'IEPS 9%' },
        { value: 0.03, label: 'IEPS 3%' },
    ]

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={onCancel}
            style={customStyles}
            shouldCloseOnEsc={true}
            shouldCloseOnOverlayClick={true}
            contentLabel="FiscalPOP Modal"
        >
            {
                item ?
                    <>
                        <div id="_FiscalpopDialog">
                            <h4>
                                Configurar {item.item.itemName.substring(0, 45)}
                            </h4>
                        </div>
                        <form id="FiscalpopDialog" onSubmit={onSubmit}>
                            <div className="fields">
                                <AutoComplete
                                    isLoading={isLoading}
                                    placeholder="Clave producto o servicio default a usar"
                                    label="Clave producto o servicio"
                                    value={defaultClaveSatProdServ}
                                    displayLabel={true}
                                    type="text"
                                    hasError={prodServErr}
                                    onBlur={claveProdErrTest}
                                    onSelect={onSelectedClaveProd}
                                    onChange={onClaveChange}
                                    options={claveOptions} />

                                <AutoComplete
                                    isLoading={isLoading}
                                    placeholder="Clave de unidad default a usar"
                                    label="Clave de Unidad de medida"
                                    value={defaultUnidadSat}
                                    displayLabel={true}
                                    type="text"
                                    hasError={unidadErr}
                                    onBlur={unitErrTest}
                                    onSelect={onSelectedUnidad}
                                    onChange={onUnidadChange}
                                    options={unidadOptions} />
                                <div className="taxBlock">
                                    <Select value={ivaOption} onChange={setIvaOption} options={ivaOptions} label="IVA %" />
                                    <Select value={ieps} onChange={setIEPS} options={iepsOptions} label="IEPS %" />
                                </div>
                                <div className="taxBlock inputHeight able">
                                    <Checkbox label="Usa Pedimento" onChange={setIsPedimento} value={isPedimento} color="#AC2E78" />
                                    {
                                        isPedimento ?
                                            <Input value={pedimento} label={'Número de Pedimento'} type="text" onChange={setPedimento} placeholder="12 12 1234 1234567" hasError={!!pedimento && (pedimento.length !== 21)} />
                                            : null
                                    }
                                </div>
                            </div>
                            <div className="actions">
                                <Button secondary={true} type={'button'} disabled={false} handleClick={onCancel}><span>Cancelar</span></Button>
                                <Button primary={true} type={'submit'} disabled={(prodServErr || unidadErr) || !(defaultClaveSatProdServ && defaultUnidadSat)}><span>Guardar</span></Button>
                            </div>
                        </form>
                    </>
                    : ''
            }
        </Modal>
    )
}


export default ItemEditModal;